import { RedoClient } from "@redotech/redo-api-client";
import { CART_ATTRIBUTE_KEY } from "@redotech/redo-model/extended-warranty";
import { ShopifyAjaxClient } from "@redotech/shopify-client/ajax";
import {
  getAutocheck,
  ShopifyExtensionClient,
} from "../../client/shopify-extension-client";
import { StorefrontClient } from "../../client/storefront";
import { initialize as initializeExtendedWarranty } from "../../extended-warranty/pdp-options/initializer";
import { log } from "../../monitoring/log";
import { getStorefrontAccessToken } from "../../utils";

void import("./styles.css");

async function initialize() {
  log("Initializing Extended Warranty Options");
  const containerFromLiquidFile = document.getElementById(
    "redo-extended-warranty-options-target",
  );

  if (!containerFromLiquidFile) {
    return;
  }

  const redoClient = new RedoClient(
    globalThis.redoStorefront?.env?.REDO_API_URL ?? process.env.REDO_API_URL!,
  );
  const ajaxClient = ShopifyAjaxClient.fromEnv();
  const widgetClient = new ShopifyExtensionClient(
    redoClient,
    globalThis.redoWidgetId,
    globalThis.redoStorefront?.storeUrl ??
      globalThis.Shopify?.shop ??
      globalThis.Shopify?.Checkout?.apiHost,
  );

  const customerId =
    (globalThis as any).ShopifyAnalytics?.meta.page.customerId || null;

  const autocheck = await getAutocheck(widgetClient, { customerId });

  try {
    const cart = await ajaxClient.cartGet();
    // Initialize the cart attribute if it doesn't exist
    if (!cart?.attributes?.[CART_ATTRIBUTE_KEY]) {
      await ajaxClient.updateCartAttribute({
        attributes: [{ key: CART_ATTRIBUTE_KEY, value: JSON.stringify({}) }],
      });
    }
  } catch (error) {
    log("Error initializing cart attribute", error);
  }

  const shopifyClient = new StorefrontClient(
    globalThis.Shopify?.shop ?? globalThis.Shopify?.Checkout?.apiHost ?? "",
    getStorefrontAccessToken(autocheck) ?? "",
    (await ajaxClient.cartGet()).token!,
  );

  initializeExtendedWarranty(shopifyClient, containerFromLiquidFile);
}

void initialize();
